// http-error.interceptor.ts

import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        // Hier kannst du die Fehlermeldung anpassen, je nachdem, wie die Fehlerstruktur aussieht
        const errorMessage =
          error.error.message || 'Unerwarteter Fehler aufgetreten';
        alert(errorMessage);

        // Weiterleitung des Fehlers, um es anderen Interceptor oder der aufrufenden Komponente zu ermöglichen, damit umzugehen
        return throwError(error);
      })
    );
  }
}
